<template>
  <form ref="joinForm" v-on:submit="submit" method="get" :action="formAction">
    <div v-if="showMessage" class="row text-center">Il meeting non è ancora iniziato, appena inizierà verrai redirezionato
      automaticamente.
    </div>
    <div class="row justify-content-center">
      <button ref="joinFormButton" :disabled="showMessage" class="btn btn-primary" type="submit">
        <span v-if="showMessage" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Partecipa
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

export default {
  name: "JoinMeetingForm",
  data() {
    return {
      meetingStarted: false,
      showMessage: false,
    }
  },
  props: {
    formAction: String,
    requestUrl: String,
  },
  methods: {
    submit: function (event) {
      if (!this.meetingStarted) {
        event.preventDefault();
        this.loop()
        this.showMessage = true
      }
    },
    checkRunning: function (callback) {
      axios.get(`${this.requestUrl}/running`).then(function (response) {
        callback(response.data);
      });
    },
    loop: function () {
      this.checkRunning(function (response) {
        this.meetingStarted = response.result;
        if (this.meetingStarted) {
          this.showMessage = false;
          this.$refs.joinForm.submit();
        } else {
          setTimeout(this.loop.bind(this), 5000);
        }
      }.bind(this))
    }
  },
  mounted() {
    this.checkRunning(function (response) {
      this.meetingStarted = response.result;
    }.bind(this));
  }

}
</script>

<style scoped>

</style>
